import { NavLink } from 'react-router-dom';

import MuiButton from '@mui/material/Button';
import MuiDivider from '@mui/material/Divider';
import MuiMenu from '@mui/material/Menu';
import { styled } from '@mui/material/styles';

import SelectorSkeleton from '#client/components/Skeleton';

export const Button = styled(MuiButton)(({ theme }) => ({
  display: 'flex',
  gap: '0.5rem',
  justifyContent: 'space-between',
  maxWidth: '100%',
  width: '100%',

  '&.MuiButtonBase-root': {
    borderRadius: '0.5rem',
    height: 'auto',
    padding: '0.75rem 1rem'
  },

  '&:hover': {
    background: theme.palette.peace50.main,
    color: theme.palette.focus00.main,

    '& .MuiButtonBase-root svg': {
      fill: theme.palette.focus00.main
    }
  },

  [theme.breakpoints.up('md')]: {
    fontSize: '1.25rem',
    width: 'auto',

    '&.MuiButtonBase-root': {
      paddingBlock: '1.125rem'
    }
  }
}));

export const Divider = styled(MuiDivider)(({ theme }) => ({
  border: 'none',
  height: 1,
  background: theme.palette.focus20.main
}));

export const Link = styled(NavLink)(({ theme }) => ({
  display: 'flex',
  gap: '0.75rem',
  padding: '0.75rem 1.5rem',
  fontSize: '1rem',
  lineHeight: '1.5',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    fontSize: '1.125rem'
  },

  [theme.breakpoints.up('md')]: {
    fontSize: '1.25rem',
    lineHeight: '1.75rem'
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: '1.375rem',
    paddingBlock: '1.125rem'
  }
}));

export const Menu = styled(MuiMenu)(({ theme }) => ({
  '& .MuiMenu-paper': {
    border: 'none',
    borderRadius: '1rem',
    boxShadow: '0 0.5rem 1rem 0.25rem rgba(46, 46, 46, 0.15)',
    marginTop: '0.25rem',
    padding: '14px 0px',
    width: '100%'
  },
  '&:focus': {
    boxShadow: 'none'
  },
  '& .MuiList-padding': {
    padding: 0
  },
  '& .MuiListItem-button:hover': {
    background: 'none'
  },
  [theme.breakpoints.up('md')]: {
    width: 500
  }
}));

export const Skeleton = styled(SelectorSkeleton)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: '16rem'
  }
}));

export const TruncatedText = styled('span')(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));
